import { FC, SVGProps } from 'react';

export const BlockIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 4.25C9.51065 4.25 4.25 9.51065 4.25 16C4.25 22.4893 9.51065 27.75 16 27.75C22.4893 27.75 27.75 22.4893 27.75 16C27.75 9.51065 22.4893 4.25 16 4.25ZM5.75 16C5.75 10.3391 10.3391 5.75 16 5.75C18.8159 5.75 21.3666 6.88549 23.2191 8.72356L8.32316 22.792C6.72201 20.9836 5.75 18.6053 5.75 16ZM9.39751 23.8406C11.181 25.344 13.4847 26.25 16 26.25C21.6609 26.25 26.25 21.6609 26.25 16C26.25 13.6951 25.4892 11.5678 24.205 9.85569L9.39751 23.8406Z"
			fill="currentColor"
		/>
	</svg>
);
